/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * Widget to display additional route information in a panel over the map.
 *
 * The panel contains an icon, distance and arrival time for the route.
 * 
 * This widget requires route data to work correcly. For more information please refer to our 
 * <a href="https://developer.tomtom.com/maps-sdk-web/functional-examples#routing_ab_summary" target="_blank">
 * Routing with summary example</a>.
 *
 * @example
 * ```javascript
 * var widget = new L.RouteSummary({
 *   size: [270, 268],
 *   position: 'topleft'
 * });
 * widget.addTo(map);
 * ```
 *
 * @class RouteSummary
 * @namespace L
 * @extends L.Control
 * @module Widgets
 * @constructor
 * @method routeSummary
 * @param {Object} [options] Options to setup control
 * @param {Number[]} [options.size=[320,320]]  Width and height in pixels for the panel
 * @param {"topleft"|"topright"|"bottomleft"|"bottomright"} [options.position="topleft"] Where to add view
 * @param {Boolean} [options.imperialDistance=null] Set this option if you want to use a specific unit measurement
 *     system for the new instance of the widget.
 *     If no unit system is defined upon, the widget will use the global unit measurement configuration.
 */
/* jshint nomen:false */
define(['display/map', 'unitFormatConverter/unitFormatConverter', '../../config/unit/unitTypes'],
    function(L, unitFormatConverter, unitTypes) {
        'use strict';

        function initPanelResult(className, control) {
            var divPanelRouteResultWrapper = L.DomUtil
                .create('div', className + '-route-result-wrapper', control.divPanelRouteResult);
            control.divPanelRouteResult = L.DomUtil.create('div', className + '-route-result', control._container);
            control.divPanelRouteDeparture = L.DomUtil.create('div', className + '-leave', control.divPanelRouteResult);
            control.divPanelRouteDeparture.innerHTML = 'Leave: now';
            control.divPanelRouteCostModel = L.DomUtil
                .create('div', className + '-route-cost-model', divPanelRouteResultWrapper);
            control.divPanelRouteTime = L.DomUtil.create('div', className + '-route-time', divPanelRouteResultWrapper);

            control.divPanelRouteTrafficDelay = L.DomUtil
                .create('div', className + '-route-traffic-delay', divPanelRouteResultWrapper);
        }

        function createPanelArriveDistance(className, control, parent) {
            var divPanelRouteArriveDistance = L.DomUtil.create('div', className + '-route-arrive-row', parent);
            var divPanelRouteArriveDistanceLabel = L.DomUtil.create('div', className + '-route-arrive-cell-left',
                divPanelRouteArriveDistance);
            divPanelRouteArriveDistanceLabel.innerHTML = 'Distance:';
            control.divPanelRouteArriveDistanceValue = L.DomUtil.create('div', className + '-route-arrive-cell-right',
                divPanelRouteArriveDistance);
        }

        function createPanelArriveTime(className, control, parent) {
            var divPanelRouteArriveTime = L.DomUtil.create('div', className + '-route-arrive-row', parent);
            var divPanelRouteArriveTimeLabel = L.DomUtil
                .create('div', className + '-route-arrive-cell-left', divPanelRouteArriveTime);

            divPanelRouteArriveTimeLabel.innerHTML = 'Arrive:';

            control.divPanelRouteArriveTimeValue = L.DomUtil
                .create('div', className + '-route-arrive-cell-right', divPanelRouteArriveTime);
        }

        function initPanelArrive(className, control) {
            var divPanelRouteArrive = L.DomUtil.create('div', className + '-arrive', control._container);
            createPanelArriveDistance(className, control, divPanelRouteArrive);
            createPanelArriveTime(className, control, divPanelRouteArrive);
        }

        function createDOMElements(control) {
            var className = 'leaflet-control-route-summary',
                container = L.DomUtil.create('div', className + ' leaflet-control'),
                divHeading = L.DomUtil.create('div', className + '-heading', container);
            container.style.width = control.options.size[0] + 'px';
            container.style.height = control.options.size[1] + 'px';
            divHeading.innerHTML = 'Route summary';
            L.DomEvent.disableClickPropagation(container);
            L.DomEvent.disableScrollPropagation(container);
            control._container = container;
            initPanelResult(className, control);
            initPanelArrive(className, control);
            container.style.visibility = 'hidden';

            return container;
        }

        L.RouteSummary = L.Control.extend({
            includes: L.Evented.prototype,

            options: {
                size: [320, 320],
                position: 'topleft',
                imperialDistance: null
            },

            /**
             * @ignore
             * This store the route summary data currently visible in the widget.
             * @type {Object}
             */
            _currentData: null,

            /**
             * @ignore
             * @type {Boolean}
             */
            _currentDataShouldBeImperial: null,

            /**
             * Leaflet init method executed when adding control to map.
             * Options will be stored inside control.
             *
             * @ignore
             * @method initialize
             * @param {Object} [options] Options to setup control
             */
            initialize: function(options) {
                L.Util.setOptions(this, options);
                this._attributions = {};
            },

            /**
             * Leaflet method executed when adding control to map.
             * Map will be stored inside control.
             *
             * @ignore
             * @method onAdd
             * @param {Object} map The map instance to which control is added.
             * @return {HTMLElement}
             */
            onAdd: function(map) {
                this.unitService = map.getUnitService();
                this.unitService.on(L.UnitService.Events.UNIT_CHANGED, this._redraw, this);
                return createDOMElements(this);
            },

            /**
             * @ignore
             */
            onRemove: function() {
                this.unitService.off(L.UnitService.Events.UNIT_CHANGED, this._redraw, this);
            },

            /**
             * Hides the route summary.
             *
             * By default the summary will be hidden until the method
             * {{#crossLink "L.RouteSummary/updateSummaryData:method"}}{{/crossLink}} is called.
             *
             * @method hide
             */
            hide: function() {
                this._container.style.visibility = 'hidden';
            },

            /**
             * Shows the route summary.
             *
             * By default summary will be hidden.
             * Use this method to show the control after data is ready.
             *
             * @method show
             */
            show: function() {
                this._container.style.visibility = '';
            },

            /**
             * Method to update data after route is recalculated.
             *
             * Use this method to update data after each route calculation.
             *
             * @method updateSummaryData
             * @param {Object} routeSummary Routing properties object
             * @param {Number} routeSummary.travelTimeInSeconds
             * @param {Number} routeSummary.trafficDelayInSeconds
             * @param {Number} routeSummary.lengthInMeters
             * @param {String|Number} routeSummary.arrivalTime Date in milliseconds or a string in RFC-3339 format
             * @param {Boolean} [useImperial=null] If you set this parameter the unit system will be forced
             *     but only for this data
             */
            updateSummaryData: function(routeSummary, useImperial) {
                this._currentData = routeSummary;
                this._currentDataShouldBeImperial = useImperial;
                this._redraw();
            },

            _redraw: function() {
                var data = this._currentData,
                    useImperial = this._shouldUseImperialDistance(),
                    converter = unitFormatConverter;
                if (typeof this._currentDataShouldBeImperial === 'boolean') {
                    useImperial = this._currentDataShouldBeImperial;
                }
                if (data) {
                    this.divPanelRouteTime.innerHTML = converter.formatTime(data.travelTimeInSeconds);
                    this.divPanelRouteTrafficDelay.innerHTML = converter
                        .formatTime(data.trafficDelayInSeconds) + ' traffic';
                    this.divPanelRouteArriveDistanceValue.innerHTML = converter
                        .formatDistance(data.lengthInMeters, useImperial);
                    this.divPanelRouteArriveTimeValue.innerHTML = converter.formatHourAndMinute(data.arrivalTime);
                    this.show();
                } else {
                    this.hide();
                }
            },

            /**
             * @ignore
             * First check the configuration for this instance and then the global configuration.
             * The instance configuration has priority.
             *
             * @return {Boolean}
             */
            _shouldUseImperialDistance: function() {
                if (typeof this.options.imperialDistance === 'boolean') {
                    return this.options.imperialDistance;
                }
                return this.unitService.getCurrentUnit().getLabel() === unitTypes.imperial;
            }
        });

        return function(options) {
            return new L.RouteSummary(options);
        };
    });



// WEBPACK FOOTER //
// ./widgets/views/routeSummary.js